import axios from "axios";
import useSWRImmutable from "swr/immutable";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import type { ZoneTendueLookup } from "../models/property";

const GEOCODE_URL = "https://data.geopf.fr/geocodage/search";
const POSTCODE_REGEXP = /^\d{5}$/;

interface MunicipalityFeature {
  properties: { citycode: string; city: string };
}

export interface ZoneTendueDetection {
  commune: string;
  lookup: ZoneTendueLookup;
}

/**
 * Zone tendue d'un logement d'après son code postal et sa ville : la commune est
 * géocodée (code INSEE) puis cherchée dans la liste du décret par le back.
 */
export default function useZoneTendue(cp: string, ville: string) {
  const authenticatedAxios = useAuthenticatedAxios();
  const villeTrimmed = ville.trim();
  const { data, isLoading } = useSWRImmutable(
    POSTCODE_REGEXP.test(cp) && villeTrimmed.length > 1
      ? ["zone-tendue", cp, villeTrimmed]
      : null,
    async ([, postcode, q]): Promise<ZoneTendueDetection | null> => {
      const geocoding = await axios.get<{ features: MunicipalityFeature[] }>(
        GEOCODE_URL,
        { params: { q, postcode, type: "municipality", limit: 1 } },
      );
      const municipality = geocoding.data.features[0];
      if (!municipality) {
        return null;
      }
      const { data: lookup } = await authenticatedAxios.get<ZoneTendueLookup>(
        "/biens/zone-tendue",
        { params: { code_insee: municipality.properties.citycode } },
      );
      return { commune: municipality.properties.city, lookup };
    },
  );

  return { detection: data ?? null, isLoading };
}
